export default "__VITE_ASSET__eed73bca__"